/*
 * @Author: 汪俊洪
 * @Date: 2022-03-11 15:30:49
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2022-03-11 16:11:59
 * @Description: 日期的快捷选择
 */
import { formateDate } from '@/utils/formateDate'

// 获取这周的周一
function getFirstDayOfWeek (date) {
  const weekday = date.getDay() || 7 // 获取星期几,getDay()返回值是 0（周日） 到 6（周六） 之间的一个整数。0||7为7，即weekday的值为1-7
  date.setDate(date.getDate() - weekday + 1)// 往前算（weekday-1）天，年份、月份会自动变化
  return formateDate('yyyy-MM-dd 00:00:00', date)
}

export const shortcuts = [
  {
    text: '当日',
    onClick (picker) {
      const start =
        new Date(formateDate('yyyy-MM-dd', new Date())).getTime() -
        3600 * 1000 * 8
      const end = start + 3600 * 1000 * 24 - 1000
      picker.$emit('pick', [new Date(start), new Date(end)])
    }
  },
  {
    text: '本周',
    onClick (picker) {
      const start = new Date(getFirstDayOfWeek(new Date()))
      const end = start.getTime() + 3600 * 1000 * 24 * 7 - 1000
      picker.$emit('pick', [start, new Date(end)])
    }
  },
  {
    text: '本月',
    onClick (picker) {
      const now = new Date() // 当前日期
      const nowMonth = now.getMonth() // 当前月
      const nowYear = now.getFullYear() // 当前年
      // 本月的开始时间
      const monthStartDate = new Date(nowYear, nowMonth, 1)
      // 本月的结束时间
      const monthEndDate = new Date(nowYear, nowMonth + 1, 1).getTime() - 1000
      picker.$emit('pick', [monthStartDate, new Date(monthEndDate)])
    }
  },
  {
    text: '本季',
    onClick (picker) {
      const now = new Date() // 当前日期
      const nowMonth = now.getMonth() // 当前月
      const nowYear = now.getFullYear() // 当前年
      const num = Math.floor(nowMonth / 3) // 取整 判断是第几个季度
      const start = new Date(nowYear, num * 3, 1)
      const end = new Date(nowYear, (num + 1) * 3, 1).getTime() - 1000
      picker.$emit('pick', [new Date(start), new Date(end)])
    }
  },
  {
    text: '本年',
    onClick (picker) {
      const now = new Date() // 当前日期
      const nowYear = now.getFullYear() // 当前年
      const start = new Date(nowYear, 0, 1)
      const end = new Date(nowYear + 1, 0, 1).getTime() - 1000
      picker.$emit('pick', [start, new Date(end)])
    }
  }
]

// 选择月份范围-快捷选项
export const monthShortcuts = [
  shortcuts[2], shortcuts[3], shortcuts[4]
]

// 季度选择
export const quarterShortcuts = [
  {
    text: '第一季度',
    onClick (picker) {
      const currentDate = new Date()
      const currentYear = currentDate.getFullYear()

      /* 第一季度 */
      const start = new Date(currentYear, 0, 1)
      const end = new Date(currentYear, 2, 31)
      end.setHours(23, 59, 59, 0)
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '第二季度',
    onClick (picker) {
      const currentDate = new Date()
      const currentYear = currentDate.getFullYear()

      /* 第二季度 */
      const start = new Date(currentYear, 3, 1)
      const end = new Date(currentYear, 5, 30)
      end.setHours(23, 59, 59, 0)
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '第三季度',
    onClick (picker) {
      const currentDate = new Date()
      const currentYear = currentDate.getFullYear()

      /* 第三季度 */
      const start = new Date(currentYear, 6, 1)
      const end = new Date(currentYear, 8, 30)
      end.setHours(23, 59, 59, 0)
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '第四季度',
    onClick (picker) {
      const currentDate = new Date()
      const currentYear = currentDate.getFullYear()

      /* 第四季度 */
      const start = new Date(currentYear, 9, 1)
      const end = new Date(currentYear, 11, 31)
      end.setHours(23, 59, 59, 0)
      picker.$emit('pick', [start, end])
    }
  }
]

// 选择多个月份-快捷选项（回传月份数组）
export const monthArrayShortcuts = [
  {
    text: '本月',
    onClick (picker) {
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const monthStr = month >= 10 ? month : '0' + month
      const ym = picker.format === 'yyyyMM' ? `${year}${monthStr}` : `${year}-${monthStr}`
      picker.$emit('pick', [`${ym}`])
    }
  }, {
    text: '本季',
    onClick (picker) {
      const now = new Date() // 当前日期
      const month = now.getMonth() // 当前月
      const year = now.getFullYear() // 当前年
      const num = Math.floor(month / 3) // 取整 判断是第几个季度
      const quarterList = [[1, 2, 3], [4, 5, 6], [7, 8, 9], [10, 11, 12]]
      const monthList = []
      quarterList[num].forEach(item => {
        const monthStr = item >= 10 ? item : '0' + item
        const ym = picker.format === 'yyyyMM' ? `${year}${monthStr}` : `${year}-${monthStr}`
        monthList.push(`${ym}`)
      })
      picker.$emit('pick', monthList) // 本季所有月份
    }
  }, {
    text: '本年',
    onClick (picker) {
      const date = new Date()
      const year = date.getFullYear()
      const monthList = []
      for (let i = 1; i <= 12; i++) {
        const monthStr = i >= 10 ? i : '0' + i
        const ym = picker.format === 'yyyyMM' ? `${year}${monthStr}` : `${year}-${monthStr}`
        monthList.push(`${ym}`)
      }
      picker.$emit('pick', monthList) // 本年所有月份
    }
  }, {
    text: '第一季度',
    onClick (picker) {
      const now = new Date() // 当前日期
      const year = now.getFullYear() // 当前年
      const quarterList = [[1, 2, 3], [4, 5, 6], [7, 8, 9], [10, 11, 12]]
      const monthList = []
      quarterList[0].forEach(item => {
        const monthStr = item >= 10 ? item : '0' + item
        const ym = picker.format === 'yyyyMM' ? `${year}${monthStr}` : `${year}-${monthStr}`
        monthList.push(`${ym}`)
      })
      picker.$emit('pick', monthList) // 本季所有月份
    }
  }, {
    text: '第二季度',
    onClick (picker) {
      const now = new Date() // 当前日期
      const year = now.getFullYear() // 当前年
      const quarterList = [[1, 2, 3], [4, 5, 6], [7, 8, 9], [10, 11, 12]]
      const monthList = []
      quarterList[1].forEach(item => {
        const monthStr = item >= 10 ? item : '0' + item
        const ym = picker.format === 'yyyyMM' ? `${year}${monthStr}` : `${year}-${monthStr}`
        monthList.push(`${ym}`)
      })
      picker.$emit('pick', monthList) // 本季所有月份
    }
  }, {
    text: '第三季度',
    onClick (picker) {
      const now = new Date() // 当前日期
      const year = now.getFullYear() // 当前年
      const quarterList = [[1, 2, 3], [4, 5, 6], [7, 8, 9], [10, 11, 12]]
      const monthList = []
      quarterList[2].forEach(item => {
        const monthStr = item >= 10 ? item : '0' + item
        const ym = picker.format === 'yyyyMM' ? `${year}${monthStr}` : `${year}-${monthStr}`
        monthList.push(`${ym}`)
      })
      picker.$emit('pick', monthList) // 本季所有月份
    }
  }, {
    text: '第四季度',
    onClick (picker) {
      const now = new Date() // 当前日期
      const year = now.getFullYear() // 当前年
      const quarterList = [[1, 2, 3], [4, 5, 6], [7, 8, 9], [10, 11, 12]]
      const monthList = []
      quarterList[3].forEach(item => {
        const monthStr = item >= 10 ? item : '0' + item
        const ym = picker.format === 'yyyyMM' ? `${year}${monthStr}` : `${year}-${monthStr}`
        monthList.push(`${ym}`)
      })
      picker.$emit('pick', monthList) // 本季所有月份
    }
  }
]
